import React, { useEffect, useState, useLayoutEffect } from 'react'
import { URLS } from '../../helpers/URLS';
import { useNavigate } from 'react-router-dom';
import { Outlet } from "react-router-dom";
import AdminHeader from '../AdminHeader/AdminHeader';
import AdminNav from '../AdminNav/AdminNav';
import useAxios from '../../helpers/Hooks/useAxios';
import './Dashboard.scss';
import { useDispatch } from 'react-redux';
import { setLoggedinUser } from '../../Redux/reducer';
import ProfileSetupModal from '../../views/ProfilePage/ProfileSetupModal';
import { ChatProvider } from '../../Context/ChatContext';
import AssistantGate from '../Assistant/AssistantDock';

const Header = () => {

    const { fetchData } = useAxios();
    const dispatch=useDispatch()

    const navigate = useNavigate();

    const [toggle, setToggle] = useState(true);

    const [user, setUser] = useState({
        employee: {
            employeeCode: "",
            employeeName: "",
            id: "",
            totalData: {}
        },
        roles: {
            daily: false,
            isTeam: false,
            isProjects: false,
            isLeaveApprover: false
        },
        menu: []
    })

    /* the mandatory first-login profile popup; the server decides when it is
       still owed, so it follows the employee to whichever page they land on */
    const [profileSetupRequired, setProfileSetupRequired] = useState(false);

    const getUserProfle = async () => {
        const resp = await fetchData({ url: URLS.user, method: 'get' });
        if (resp.status === 200) {
            setUser(resp.data)
            setProfileSetupRequired(Boolean(resp.data.profileSetupRequired))
            dispatch(setLoggedinUser(resp.data))
        } else {
            navigate("/")
        }
    }

    useEffect(() => {
        getUserProfle();
    }, [])

    useLayoutEffect(() => {
        window.addEventListener('resize', () => {
            setToggle(window.innerWidth > 1025 ? true : false);
        });
    }, [])

    return (
        /* Wrapped here rather than around a route, because a message has to be
           able to arrive and open a window on any page — and because this is
           the first point at which the signed-in employee is known, which the
           socket needs before it can connect. */
        <ChatProvider user={user.employee}>
            <div className='dashboard_section'>
                <div className='admin-bg d-flex p-0'>
                    <AdminNav setToggle={setToggle} toggle={toggle} user={user.employee} menu={user.menu} />
                    <div id="content" className={`s${toggle ? '' : 'active'}`} style={{ backgroundColor: " bg-light" }}>
                        <AdminHeader setToggle={setToggle} toggle={toggle} user={user} />
                        <div className='container py-3 pe-0 p-lg-3 outlet_scroll'>
                            <Outlet />
                        </div>
                    </div>
                </div>
                {toggle && <div className='mobile-sidebar-overlay-container' onClick={() => setToggle(false)}></div>}

                <ProfileSetupModal
                    open={profileSetupRequired}
                    user={user.employee}
                    onCompleted={() => {
                        setProfileSetupRequired(false);
                        getUserProfle();
                    }}
                />

                <AssistantGate user={user.employee} />
            </div>
        </ChatProvider>
    )
}

export default Header;
